// components/AudioDownloadModal.jsx
export default function AudioDownloadModal({ onClose, onSubscribe }) {
  return (
    <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full shadow-xl border border-green-200 text-center">
        <h2 className="font-bold text-xl text-green-800 mb-3">Audio Download Restricted</h2>
        <p className="mb-5 text-gray-800">
          Sorry, audio downloads are only available to Choir Supporters and Choir Experts.<br />
          <span className="block mt-2">
            Support Choir Center by subscribing. You'll enjoy unlimited access to all resources and help us keep the platform online!
          </span>
        </p>
        <div className="flex flex-col gap-3 mt-4">
          <button
            onClick={onSubscribe}
            className="bg-lime-600 text-white font-semibold px-6 py-2 rounded-full hover:bg-lime-700"
          >
            Subscribe Now
          </button>
          <button
            onClick={onClose}
            className="bg-gray-200 text-green-900 font-semibold px-6 py-2 rounded-full hover:bg-gray-300"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
